export default __webpack_public_path__ + "static/media/zig_zag.ba39f61a.svg";